export default "__VITE_ASSET__f3cb578d__"